import { OPTUM_FRONTIER_THERAPIES } from "shared/src/data/providerNames";
import { useProviderName } from "./useProviderName";

export function useAllowSucraid(): boolean {
  const providerName = useProviderName();
  return providerName?.includes(OPTUM_FRONTIER_THERAPIES) ?? false;
}
